import { apiGet } from '@/store/api';
import { useApplicationStore } from '@/store/applicationStore';

export async function getFavorites() {
  const applicationStore = useApplicationStore();
  const data = await apiGet('favorites');
  applicationStore.setFavorites(data);
}
